import React, { useCallback, useMemo } from "react";
import { Grid } from "@pushpress/shared-components";
import { createCreditsCount } from "./AppointmentCredits.utils";
import CreditsSummary from "./CreditsSummary";
import CreditsTable from "./CreditsTable";
import { CreditFragment } from "./AppointmentCredits-generated.hooks";
import AppointmentActionsMenu from "../AppointmentActionsMenu";

interface CreditsTabProps {
  memberId: string;
  data: CreditFragment[];
  loading: boolean;
  refetch: VoidFunction;
}

function CreditsTab(props: CreditsTabProps) {
  const { memberId, data, loading, refetch } = props;

  const creditsCount = useMemo(() => {
    return createCreditsCount(data || []);
  }, [data]);

  const renderRowMenu = useCallback(
    (selectedDataRow: CreditFragment, closeMenu: VoidFunction) => {
      return (
        <AppointmentActionsMenu
          onClose={closeMenu}
          userUuid={memberId}
          appointmentUuid={selectedDataRow?.uuid}
          expiresAt={selectedDataRow?.expiresAt}
          status={selectedDataRow?.eventStatus}
          onSuccess={refetch}
        />
      );
    },
    [refetch, memberId],
  );

  return (
    <Grid container spacing={3} columnSpacing={3}>
      <Grid item xs={12} lg={3} orderXs={1} orderLg={2}>
        <CreditsSummary data={creditsCount} />
      </Grid>
      <Grid item xs={12} lg={9} orderXs={2} orderLg={1}>
        <CreditsTable
          data={data}
          loading={loading}
          renderRowMenu={renderRowMenu}
        />
      </Grid>
    </Grid>
  );
}

export default CreditsTab;
